import { initialAmpelSystemState } from "../mealyModels/AmpelSystem/ampelSystemState";
import { initialDoorSystemState } from "../mealyModels/DoorSystem/doorSystemState";
import { initialGaragentorSystemState } from "../mealyModels/Garagentor/garagentorSystemState";
import { MealyModelType } from "../mealyModels/mealyModelType";
import { initialMachineStateMealy } from "../state/machineState";
import { initialState } from "../state/state";
export function file_load(state, saveObject) {
    // return produce(state, draftState => {
    //     draftState.machineState.machine = machine;
    // });
    if (saveObject.type === 'SaveObjectMealy') {
        if (saveObject.mealyModelType === MealyModelType.AMPELSYSTEM) {
            return Object.assign(Object.assign({}, initialState), { machineState: Object.assign(Object.assign({}, initialMachineStateMealy), { machine: saveObject.machine, mealyModelType: saveObject.mealyModelType, ampelSystemState: initialAmpelSystemState }) });
        }
        else if (saveObject.mealyModelType === MealyModelType.GARAGENTOR) {
            return Object.assign(Object.assign({}, initialState), { machineState: Object.assign(Object.assign({}, initialMachineStateMealy), { machine: saveObject.machine, mealyModelType: saveObject.mealyModelType, garagentorSystemState: initialGaragentorSystemState }) });
        }
        else if (saveObject.mealyModelType === MealyModelType.DOORSYSTEM) {
            return Object.assign(Object.assign({}, initialState), { machineState: Object.assign(Object.assign({}, initialMachineStateMealy), { machine: saveObject.machine, mealyModelType: saveObject.mealyModelType, doorSystemState: initialDoorSystemState }) });
        }
        else {
            return Object.assign(Object.assign({}, initialState), { machineState: Object.assign(Object.assign({}, initialMachineStateMealy), { machine: saveObject.machine, mealyModelType: saveObject.mealyModelType }) });
        }
    }
    else if (saveObject.type === 'SaveObjectDEA') {
        // TODO
    }
}
